<div class="subpage-container">
  <div class="container g-0 m-0">
    <div class="row g-0 m-0 d-flex align-items-center pt-4">
      <div class="col-md-9 ps-5 pt-4 pb-4">
        <h2 class="col pb-2 title">{{ "FIRMWARE_UPDATE" | translate }}</h2>
      </div>
      <div class="col-md-3 pe-5 pt-4 pb-4 d-flex justify-content-end">
        <button class="button-add-device" (click)="updateFirmware()">
          {{ "UPDATE_FIRMWARE" | translate }}
        </button>
      </div>
    </div>

    <div class="row d-flex align-items-center g-0 m-0 p-0 mb-3">
      <div class="col-6 d-flex justify-content-start ps-5 gap-3">
        <app-firmware-update-group-filter [numberOfResults]="numberOfGroups"
          [selectedMeterMakeIds]="selectedFilters.meterMakeIds || []"
          [selectedMeterModelIds]="selectedFilters.meterModelIds || []" [selectedStatuses]="selectedFilters.statuses"
          (applied)="onDataReceived($event)">
        </app-firmware-update-group-filter>

        <app-sort (close)="onSortOption($event)"></app-sort>

        <div class="datepicker-container-wrapper position-relative">
          <div class="button-wrapper">
            <div class="button">
              <img alt="Date" src="assets/core/table-button/date.svg" />
              <div class="button-text" (click)="toggleModal()"
                [ngClass]="{ changed: requestData.scheduledStartTime && requestData.scheduledEndTime }">
                <ng-container
                  *ngIf="requestData.scheduledStartTime && requestData.scheduledEndTime; else noDateSelected">
                  {{ selectedDate }}
                </ng-container>
                <ng-template #noDateSelected>
                  <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                </ng-template>
              </div>
              <img *ngIf="requestData.scheduledStartTime && requestData.scheduledEndTime" alt="Exit"
                src="assets/device/x.svg" (click)="clearDates()" />
            </div>
          </div>
          @if (isDatepickerOpen) {
          <div class="overlay" (click)="toggleModal()"></div>
          <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
            [inputFromDate]="requestData.scheduledStartTime" [inputToDate]="requestData.scheduledEndTime">
          </app-datepicker>
          }
        </div>
      </div>
      <div class="col-6 pe-5 d-flex justify-content-end align-items-center flex-wrap gap-2">
        <span *ngIf="selectedRows.length > 0" class="custom-color d-flex align-items-center gap-2">
          {{ selectedRows.length }} Selected
          <img alt="Clear" src="assets/device/x.svg" (click)="clearSelection()" title="Clear selection" />
        </span>
        <button *ngIf="selectedRows.length > 0 && hasSelectedInProgressGroups()" type="button"
          class="firmware-group-bulk-action-button" (click)="abortSelectedGroups()" [title]="'ABORT' | translate"
          [attr.aria-label]="'ABORT' | translate">
          <svg-icon alt="Abort" src="assets/device/delete-folder.svg"></svg-icon>
        </button>
        <button *ngIf="selectedRows.length > 0 && hasSelectedRetryableGroups()" type="button"
          class="firmware-group-bulk-action-button" (click)="retrySelectedGroups()" [title]="'RETRY' | translate"
          [attr.aria-label]="'RETRY' | translate">
          <svg-icon alt="Retry" src="assets/device/refresh.svg"></svg-icon>
        </button>
        <button *ngIf="selectedRows.length > 0 && hasSelectedScheduledGroups()" type="button"
          class="firmware-group-bulk-action-button" (click)="toggleSelectedGroupsActivation()"
          [title]="'DEACTIVATE' | translate" [attr.aria-label]="'DEACTIVATE' | translate">
          <svg-icon alt="Deactivate" src="assets/settings/deactivate.svg"></svg-icon>
        </button>
        <button *ngIf="selectedRows.length > 0 && hasSelectedDeletableGroups()" type="button"
          class="firmware-group-bulk-action-button" (click)="deleteSelectedGroups()" [title]="'DELETE' | translate"
          [attr.aria-label]="'DELETE' | translate">
          <svg-icon alt="Delete" src="assets/settings/trash-can-red.svg"></svg-icon>
        </button>
      </div>
    </div>

    <div class="row g-0 m-0">
      <table>
        <thead>
          <tr>
            <th></th>
            <th class="ps-1 fixed-col">
              <input type="checkbox" [checked]="isAllSelected()" (change)="toggleAllSelected($event)"
                (click)="$event.stopPropagation()" class="form-check-input custom-checkbox" />
            </th>
            <th>
              <img alt="Column" src="assets/device/column-menu.svg" />
              <span>{{ "METERMAKE" | translate }}</span>
            </th>
            <th>
              <img alt="Column" src="assets/device/column-menu.svg" />
              <span>{{ "DEVICESETUP_METERMODEL" | translate }}</span>
            </th>
            <th>
              <img alt="Column" src="assets/device/column-menu.svg" />
              <span>{{ "FIRMWARE_FILE" | translate }}</span>
            </th>
            <th>
              <img alt="Column" src="assets/device/column-menu.svg" />
              <span>{{ "STARTTIME" | translate }}</span>
            </th>
            <th>
              <img alt="Column" src="assets/device/column-menu.svg" />
              <span>{{ "ENDTIME" | translate }}</span>
            </th>
            <th>
              <img alt="Column" src="assets/device/column-menu.svg" />
              <span>{{ "PROGRESS" | translate }}</span>
            </th>
            <th>
              <img alt="Column" src="assets/device/column-menu.svg" />
              <span>{{ "STATUS" | translate }}</span>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of data; let i = index" class="clickable-row" (click)="seeGroupDetails(row)">
            <td appIsNew [executedTime]="row.createdAt!"></td>
            <td class="ps-1 fixed-col" (click)="checkbox.click(); $event.stopPropagation()">
              <input type="checkbox" [checked]="isRowSelected(row.id)" [id]="'checkbox-' + row.id"
                (change)="toggleRowSelection(row)" (click)="$event.stopPropagation()"
                class="form-check-input custom-checkbox" #checkbox />
            </td>
            <td>
              <span title="{{ row.firmwareVersion.meterMake }}">{{ row.firmwareVersion.meterMake || "/" }}</span>
            </td>
            <td>
              <span title="{{ row.firmwareVersion.meterModel }}">{{ row.firmwareVersion.meterModel || "/" }}</span>
            </td>
            <td>
              <span title="{{ row.firmwareVersion.firmwareFileName }}">{{ row.firmwareVersion.firmwareFileName || "/"
                }}</span>
            </td>
            <td>
              <span title="{{ (row.startTime ?? row.scheduledTime) | date: 'dd MMM yyyy, h:mm a' }}">{{ (row.startTime
                ?? row.scheduledTime) | date: "dd MMM yyyy, h:mm a" }}</span>
            </td>
            <td>
              <span title="{{ row.endTime | date: 'dd MMM yyyy, h:mm a'  }}">{{ row.endTime ? (row.endTime | date: "dd
                MMM yyyy, h:mm a") : "/"
                }}</span>
            </td>
            <td>
              <div class="progress-cell">
                <div class="progress-track">
                  <div class="progress-fill" [style.width.%]="progressPercent(row)"></div>
                  <span class="progress-label">
                    {{ row.successfulCommandsCount || 0 }} / {{ totalCommands(row) }}
                  </span>
                </div>
              </div>
            </td>
            <td class="status-cell">
              <div class="status-with-actions">
                <span class="status-pill" [ngClass]="statusClass(row.status)">
                  {{ statusText(row.status).toUpperCase() | translate }}
                </span>
                <div>
                  <button *ngIf="hasInProgressCommands(row) || hasFailedCommands(row)" type="button"
                    class="status-action-button" (click)="abortGroup(row); $event.stopPropagation()"
                    [title]="'ABORT' | translate" [attr.aria-label]="'ABORT' | translate">
                    <svg-icon alt="Abort" src="assets/device/delete-folder.svg"></svg-icon>
                  </button>
                  <button *ngIf="hasFailedCommands(row) && row.status != FirmwareUpdateGroupStatus.Aborted"
                    type="button" class="status-action-button" (click)="retryGroup(row); $event.stopPropagation()"
                    [title]="'RETRY' | translate" [attr.aria-label]="'RETRY' | translate">
                    <svg-icon alt="Retry" src="assets/device/refresh.svg"></svg-icon>
                  </button>
                </div>

              </div>
            </td>
            <td class="more-cell" [class.more-cell-active]="activeRow === i">
              <svg-icon alt="More" class="more-icon ps-1" src="assets/device/column-menu.svg"
                (click)="setActiveRow(i); $event.stopPropagation()"></svg-icon>
              <div *ngIf="activeRow === i" class="positioning">
                <div class="overlay-light" (click)="setActiveRow(null)"></div>
                <div class="dropdown-button p-2">
                  <div class="dropdown-button-menu p-0 m-0">
                    <div *ngIf="canActivateGroup(row)"
                      class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                      (click)="toggleGroupActivation(row); $event.stopPropagation()">
                      <svg-icon alt="Activate" src="assets/settings/activate.svg"></svg-icon>
                      <span class="ps-3 item-title">{{ "ACTIVATE" | translate }}</span>
                    </div>
                    <div *ngIf="canDeactivateGroup(row)"
                      class="dropdown-button-item d-flex justify-content-start align-items-center p-2"
                      (click)="toggleGroupActivation(row); $event.stopPropagation()">
                      <svg-icon alt="Deactivate" src="assets/settings/deactivate.svg"></svg-icon>
                      <span class="ps-3 item-title">{{ "DEACTIVATE" | translate }}</span>
                    </div>
                    <div class="dropdown-button-item delete d-flex justify-content-start align-items-center p-2"
                      (click)="deleteGroup(row); $event.stopPropagation()">
                      <svg-icon alt="Delete" src="assets/settings/trash-can-red.svg"></svg-icon>
                      <span class="ps-3 item-title">{{ "DELETE" | translate }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr *ngIf="data.length === 0">
            <td colspan="10" class="empty-state">{{ "NO_DATA" | translate }}</td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="container-down">
  <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfGroups" [pageSize]="pageSize"
    [currentPage]="currentPage" (pageChange)="pageChange($event)">
  </app-pagination>
</div>

<app-confirm-dialog *ngIf="isAbortModalOpen" titleKey="ABORT" question="FIRMWARE_UPDATE_ABORT_CONFIRM"
  (confirm)="confirmAbortGroups()" (cancel)="closeAbortModal()"></app-confirm-dialog>